/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import useForm from '../utils/useForm';
import { useFormStore } from '../../store';
import useTinType from '../utils/useTinType';

import { US_STATES } from '../../constants/formOptions';

const useBorrowersForm = (onSubmit, values, formId, readOnly) => {
  const { tinTypeOptions, tinInputMask } = useFormStore();

  const fields = useMemo(
    () => [
      {
        title:
          values?.position === 'secondary'
            ? 'Personal Info (Coborrower)'
            : 'Personal Info',
        fields: [
          {
            title: 'Entity Type',
            name: 'entity_type',
            type: readOnly ? 'text' : 'radio',
            options: [
              { label: 'Individual', value: 'Individual' },
              { label: 'Entity', value: 'Entity' },
            ],
            defaultValue: 'Individual',
          },
          {
            title: 'Full name',
            name: 'name',
            type: 'text',
          },
          {
            title: 'First Name',
            name: 'first_name',
            type: 'text',
          },
          {
            title: 'Last Name',
            name: 'last_name',
            type: 'text',
          },
          {
            title: 'Entity Name',
            name: 'entity_name',
            type: 'text',
            isHidden: (vals) => vals.entity_type === 'Individual',
          },
          {
            title: 'TIN Type',
            name: 'TIN_type',
            type: readOnly ? 'text' : 'radio',
            options: tinTypeOptions[formId] || [],
          },
          {
            title: 'TIN',
            name: 'TIN',
            type: 'text',
            mask: tinInputMask[formId],
            validation: 'tin',
          },
          {
            title: 'Preferred Language',
            name: 'preferred_language',
            type: 'select',
            options: [
              { value: 'English', label: 'English' },
              { value: 'Spanish', label: 'Spanish' },
            ],
          },
        ],
      },
      {
        title: 'Contact Info',
        fields: [
          {
            title: 'Email',
            name: 'email',
            type: 'text',
            validation: 'email',
          },
          {
            title: 'Mobile Phone',
            name: 'phone_mobile',
            type: 'text',
            validation: 'phone',
            mask: '(999) 999-9999',
          },
          {
            title: 'Home Phone',
            name: 'phone_home',
            type: 'text',
            validation: 'phone',
            mask: '(999) 999-9999',
          },
          {
            title: 'Work Phone',
            name: 'phone_work',
            type: 'text',
            validation: 'phone',
            mask: '(999) 999-9999',
          },
          {
            title: 'Billing Address Line 1',
            name: 'billing_address_line_1',
            type: 'text',
            required: true,
          },
          {
            title: 'Billing Address Line 2',
            name: 'billing_address_line_2',
            type: 'text',
          },
          {
            title: 'City',
            name: 'billing_city',
            type: 'text',
            required: true,
          },
          {
            title: 'State',
            name: 'billing_state',
            type: 'select',
            options: US_STATES,
            required: true,
          },
          {
            title: 'ZIP',
            name: 'billing_zip',
            type: 'text',
            validation: 'zip',
            required: true,
          },
        ],
      },
      {
        title: 'Other',
        fields: [
          {
            title: 'DOB',
            name: 'date_of_birth',
            type: 'date',
          },
          {
            title: 'QuickBooks ID',
            name: 'qb_customer_id',
            type: 'text',
          },
        ],
      },
    ],
    [formId, tinInputMask, tinTypeOptions, values?.position, readOnly]
  );

  const { formik } = useForm({ fields, onSubmit, values });

  useTinType({
    formik,
    tinTypeFieldName: 'TIN_type',
    entityNameFieldName: 'entity_type',
    formId,
    values,
  });

  return {
    formik,
    fields,
    values,
  };
};

export default useBorrowersForm;
